import { ADD_JOURNAL_VOUCHER, GET_JOURNAL_VOUCHER, UPDATE_JOURNAL_VOUCHER, DELETE_JOURNAL_VOUCHER } from '../types';

const initialState = {
   list: [],
   single: null,
};

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_JOURNAL_VOUCHER:
         return { ...state, list: payload.data , pagination: payload.pagination };

      case ADD_JOURNAL_VOUCHER:
         return { ...state, list: payload };

      case UPDATE_JOURNAL_VOUCHER:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case DELETE_JOURNAL_VOUCHER:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
         };
      default:
         return state;
   }
};

export default reducer;
